import { LocalCourseProviderData } from "@jelly/lesson";

import all from "./all";
import course01 from "./course-01/course";
import course02 from "./course-02/course";
import course03 from "./course-03/course";
import course04 from "./course-04/course";
import course05 from "./course-05/course";

const data: LocalCourseProviderData = {
  all,
  byId: {
    [course01.id]: course01,
    [course02.id]: course02,
    [course03.id]: course03,
    [course04.id]: course04,
    [course05.id]: course05,
  },
};
export default data;
